import BaseApiClient from '../BaseApiClient';

const API_VERSION = { Version: '2025-11-14' };

export type AudiencePresetContactability = {
  email: number | null;
  sms: number | null;
  whatsapp: number | null;
};

export type AudiencePresetApiItem = {
  id: string;
  name: string;
  kind: 'preset' | string;
  status: 'published' | 'draft' | string;
  size: number | null;
  owner_name: string;
  updated_at: string | null;
  entity_type?: string | null;
  subsector?: string | null;
  filter_count?: number | null;
  contactability?: AudiencePresetContactability | null;
  audience_type?: 'dynamic' | 'static' | string | null;
};

export type AudiencePresetListMeta = {
  page: number;
  per_page: number;
  total: number;
  has_more: boolean;
};

export type AudiencePresetListResponse = {
  data: AudiencePresetApiItem[];
  meta: AudiencePresetListMeta;
};

export { audiencePresetQueryKeys } from './query-keys';
export { mapAudiencePresetToCard } from './mapAudiencePreset';
export {
  usePresetAudiencesQuery,
  usePresetAudiencesInfiniteQuery,
  getPresetAudienceNextPage,
  type PresetAudiencesQueryData,
  type PresetAudiencesInfinitePage
} from './use-audience-preset-queries';
export { PRESET_AUDIENCE_HOME_PAGE_SIZE } from './constants';

export class ApiAudiencePresets extends BaseApiClient {
  async list(params?: {
    page?: number;
    per_page?: number;
  }): Promise<AudiencePresetListResponse> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/audience-presets', { headers: API_VERSION, params })
        .then((res) =>
          resolve({
            data: res.data.data ?? [],
            meta: res.data.meta ?? {
              page: params?.page ?? 1,
              per_page: params?.per_page ?? 0,
              total: (res.data.data ?? []).length,
              has_more: false
            }
          })
        )
        .catch((err) => reject(err));
    });
  }

  async get(id: string): Promise<AudiencePresetApiItem> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/audience-presets/${id}`, { headers: API_VERSION })
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err));
    });
  }
}
